import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { I18nStore } from '@indutrust/shared-data';
import { I18N_CONFIG } from '@indutrust/shared-model';
import { SelectButtonFieldComponent } from '@indutrust/shared-ui';
import { provideTranslocoScopeSharedGlobal } from '@indutrust/shared-util';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'idt-i18n',
  imports: [SelectButtonFieldComponent, TranslocoDirective],
  template: `
    <ng-container *transloco="let t; prefix: 'global'">
      <idt-select-button
        optionLabel="displayName"
        optionValue="code"
        size="small"
        [ariaLabel]="t('settings.language')"
        [options]="languages"
        [value]="i18nStore.language().code"
        (valueChange)="changeLanguage($event)" />
    </ng-container>
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
    }
  `,
  providers: [provideTranslocoScopeSharedGlobal()],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * Minimal language switcher component using PrimeNG SelectButton.
 */
export class I18nComponent {
  protected readonly i18nStore = inject(I18nStore);

  readonly languages = I18N_CONFIG.languages;

  /**
   * Switches the active application language.
   * @param languageCode - The ISO language code to activate (e.g. `'en'`, `'ar'`).
   */
  changeLanguage(languageCode: string): void {
    const language = this.languages.find(({ code }) => code === languageCode);
    if (!language) {
      return;
    }
    this.i18nStore.updateLanguage(language);
  }
}
